export default __webpack_public_path__ + "static/csaba_patkos-e53087486388aed48dcfb47dc56ca205.png";